import { createContext, useContext } from 'react';
import { useImmerReducer } from 'use-immer';
import { useLocation, useSearchParams } from "react-router-dom";
import { useCookies } from "react-cookie";
import { OpenAPI } from '../api';
import { DispatchAction, GlobalState } from '../Common';

const GlobalInitialState: GlobalState = {
  StudyId: 0,
  StudyIdentifier: "",
  PanelistId: 0,
  PsGUID: "",
  UUID:"",
  Theme: "",
  Language: "",
  App: "",
  ForceRestart: false,
  LangResources: "",
  PanelistToken: "",
  RedirectUrl: "",
  DomainName: "",
  PostSurvey: false,
  Header: [],
  Footer: [],
  isResourcesLoaded:false,
  dir: ""
};

function GlobalReducer(draft: GlobalState, action: DispatchAction) {
  switch (action.type) {
    case 'reset':
      draft = action.value
      break
    case 'setTheme':
      draft.Theme = action.value
      break
    case 'setLanguage':
      draft.Language = action.value
      break
    case 'setLanguageResources':
      draft.LangResources = action.value
      draft.isResourcesLoaded = true
      break
    case 'setHeader':
      draft.Header = action.value
      break
    case 'setFooter':
      draft.Footer = action.value
      break              
    case 'RedirectURL':
      draft.RedirectUrl = action.value
      break
    default:
      console.log("Unknown Action value.")
      break;
  }
}
const GlobalContext = createContext(GlobalInitialState);

const GlobalDispatchContext = createContext<React.Dispatch<DispatchAction>>(() => { });

export function GlobalContextProvider({ children }: any) {

  const [searchParams] = useSearchParams();
  
  let location = useLocation();
  let paths:Array<string> = location.pathname.split("/").filter(Boolean)??[];
  const [cookies] = useCookies(["X-ARCS-Authentication","portalculture"]);
  const [state, dispatch] = useImmerReducer(GlobalReducer, GlobalInitialState);
 
  const getCaseInsensitiveParam = (key:string) => {
    const entries = searchParams.entries();
    for (let [paramKey, paramValue] of entries) {
      if (paramKey.toLowerCase() === key.toLowerCase()) {
        return paramValue.toString()?.replace(/^"|"$/g, '');
      }
    }
    return null;
  };

  const setLayoutDirection = () => {
    var path = `${process.env.PUBLIC_URL}/rtl.json`;
    var lang = GlobalInitialState.Language.split('-')[0];
    
    fetch(path)
      .then((response) => {
        if (response.status !== 404) {
           response.json().then((data) => {
            var result = data['languages'].filter((f: any) => f.iso_code === lang);
            GlobalInitialState.dir = result.length > 0 ? "rtl" :"";
          });
        }
      })
  }

  if(paths.length <= 2) 
  {
      GlobalInitialState.StudyId = parseInt(getCaseInsensitiveParam("studyid")??getCaseInsensitiveParam("rq2")??"0");
      GlobalInitialState.StudyIdentifier = paths.length === 2?paths[1]:'';
      GlobalInitialState.PanelistId = parseInt(getCaseInsensitiveParam("panelistid")?? "0");
      GlobalInitialState.PsGUID = getCaseInsensitiveParam("psguid") ?? getCaseInsensitiveParam("rq4")?? "";
      GlobalInitialState.Theme = getCaseInsensitiveParam("theme") ??""; // This should only call notheme
      GlobalInitialState.App = getCaseInsensitiveParam("app")?? "";
      GlobalInitialState.UUID = getCaseInsensitiveParam("uuid")?? "";
      GlobalInitialState.RedirectUrl = getCaseInsensitiveParam("redirecturl") ?`${window.location.protocol}//${window.location.host}/${getCaseInsensitiveParam("redirecturl")}` : '';
      GlobalInitialState.DomainName =`${window.location.protocol}//${window.location.host}/`;
      GlobalInitialState.Language = getCaseInsensitiveParam("lang") ?? cookies['portalculture'] ?? navigator.language ?? "";
      GlobalInitialState.ForceRestart = getCaseInsensitiveParam("forcerestart") === 'true';
      GlobalInitialState.LangResources =  null;
      GlobalInitialState.PanelistToken = cookies['X-ARCS-Authentication'] ?? "";
      let postSurveyVal = getCaseInsensitiveParam("postsurvey")??"false";
      GlobalInitialState.PostSurvey =  postSurveyVal === "true"?true:false;
      if (OpenAPI.TOKEN === undefined || OpenAPI.TOKEN === '') {
        OpenAPI.TOKEN = cookies['X-ARCS-Authentication']
      }
      if(window.location.host !== "localhost:3000")
      {
        OpenAPI.BASE = `${window.location.protocol}//${window.location.host}/${paths[0]}`;
      } 

      setLayoutDirection();
      //console.log(JSON.stringify(languageResources.en_US));
  }
  else
  {
      console.log("Invalid URL path.");
  }
  return (
    <GlobalContext.Provider value={state}>
      <GlobalDispatchContext.Provider value={dispatch}>
        {children}
      </GlobalDispatchContext.Provider>
    </GlobalContext.Provider>
  );
}

export function useGlobalCtx() {
  return useContext(GlobalContext);
}

export function useGlobalCtxDispatch() {
  return useContext(GlobalDispatchContext);
}

